import { AlarmList } from '@models/index';
import { ISeriesConfiguration } from '../../widgets/models';
import { getIdentifiersForGroupsOnMap } from './getIdentifiersForGroupsOnMap';
import { Group } from '@models/entities';

export const getMapSeries = (groups: Group[], alarms: AlarmList) => {
    let series: ISeriesConfiguration[] = [];
    if (groups) {
        const identifiers = getIdentifiersForGroupsOnMap(groups);
        series = identifiers
            .filter((i) => !!alarms[i.guid])
            .flatMap((identifier) => {
                return alarms[identifier.guid].map((alarm) => {
                    return {
                        color: undefined,
                        guid: identifier.guid,
                        isBarsVisible: false,
                        isBoundToGroup: false,
                        isLineVisible: false,
                        isSymbolVisible: false,
                        originalGuid: identifier.guid,
                        relativePath: '',
                        serieState: 0,
                        symbol: '',
                        value: alarm.value,
                        valueType: alarm.value
                    };
                });
            });
    }
    return series;
};
